import { render, staticRenderFns } from "./XEditor.vue?vue&type=template&id=46f6a636&"
import script from "./XEditor.vue?vue&type=script&lang=js&"
export * from "./XEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports